import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../../../../model/api/form-field-config";
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {AllocationRequest} from "../../../../../../model/clearing/allocation/allocation-request";
import {AccountType} from "../../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {SingleAllocationFormBaseComponent} from "../single-allocation-form-base.component";
import {Order} from "../../../../../../model/clearing/order";
import {SignificantOrdersInfo} from "../../../../../../model/clearing/significant-orders-info";
import {ClearingOrderInfoService} from "../../../../../../services/clearing/clearing-order-info.service";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../../../model/api/api-validation";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {FieldsService} from "../../../../../../services/common/fields-service";
import {CcStorageService} from "../../../../../../services/common/cc-storage.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-update-allocation-form',
  templateUrl: './update-single-allocation-form.component.html',
  styleUrls: ['../allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateSingleAllocationFormComponent extends SingleAllocationFormBaseComponent {

  orderWholeReferenceIds: string[] = [];
  orderWholeApsGrpIds: string[] = [];
  significantOrders: Order[] = []

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
               confirmationService: ConfirmationService,
              translateService: TranslateService,
              private readonly clearingOrderInfoService: ClearingOrderInfoService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref, allocationService,
      commonFieldService, appConfigService, messageService, confirmationService, translateService, storageService,
      fieldsService);
    this.formRecord = new AllocationRequest();
    this.formRecord.accountTypeCode = AccountType.GIVE_UP_CODE;
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.update_single_allocation');
    // this.formConfig[0].fields[0].required = false;
    this.formConfig[0].fields[0].disabled = record => this.formRecord['noOrderNumberChange'];
    this.formConfig[0].fields[1].disabled = record => this.formRecord['noApsGroupChange'];
    this.formConfig.push({
      fields: [
        {
          column: 12,
          type: TYPE.NONE,
        },
        {
          column: 12,
          class: 'form-info',
          type: TYPE.NONE,
          icon: id => {
            return this.formRecord['wholeOrderNumberChange'] ? 'form-info-orange' : 'form-info-orange';
          },
          iconValue: event => {
            return this.getOrderChangeInfo();
          }
        },
        {
          column: 12,
          class: 'form-info',
          type: TYPE.NONE,
          icon: id => {
            return this.formRecord['noApsGroupChange'] ? 'form-info-green' : 'form-info-orange';
          },
          iconValue: event => {
            return this.getApsGroupChangeInfo();
          }
        },
        {
          column: 4,
          type: TYPE.CHECKBOX,
          hidden: record => this.getReferences().length > 1 || this.orderWholeReferenceIds == this.formRecord.orderIds,
          field: 'wholeOrderNumberChange'
        },
        {
          column: 4,
          type: TYPE.CHECKBOX,
          field: 'noOrderNumberChange'
        },
        {
          column: 4,
          type: TYPE.CHECKBOX,
          field: 'noApsGroupChange'
        }]
    });
    // this.formConfig.push({
    //   fields: [
    //     {
    //       column: 12,
    //       class: 'form-info over',
    //       type: TYPE.NONE,
    //       icon: id => {
    //         return this.formRecord['noApsGroupChange'] ? 'form-info-green' : 'form-info-red';
    //       },
    //       iconValue: event => {
    //         return this.getApsGroupChangeInfo();
    //       }
    //     }]
    // })
  }

  public open(selectedIds: string[], significantOrdersInfo: SignificantOrdersInfo, allocationInProgress: AllocationRequest = undefined): void {
    if (selectedIds && selectedIds.length > 0) {
      this.loadingProgressValue = 0;
      // this.allocationService.getSignificantOrders(selectedIds).subscribe(validation => {
      //   if (validation.success) {
      //     const significantOrdersInfo: SignificantOrdersInfo = validation.item;
      this.orderWholeReferenceIds = significantOrdersInfo.orderWholeReferenceIds;
      this.orderWholeApsGrpIds = significantOrdersInfo.orderWholeApsGrpIds;
      this.significantOrders = significantOrdersInfo.orders;
      this.formContractsCodes = [...new Set(this.significantOrders.map(value => value.contractCode))];

      if (!allocationInProgress) {
        allocationInProgress = new AllocationRequest();
        allocationInProgress.orderIds = selectedIds;

        // const firstOrder = this.significantOrders[0];
        allocationInProgress.clearingHouse = this.getUniqueValue(this.significantOrders, 'clearingHouse');
        allocationInProgress.exchangeCode = this.getUniqueValue(this.significantOrders, 'exchangeCode');
        allocationInProgress.owner = this.getUniqueValue(this.significantOrders, 'owner');
        if (this.getReferences().length > 1) {
          allocationInProgress['noOrderNumberChange'] = true;
          allocationInProgress['noApsGroupChange'] = true;
        } else {
          allocationInProgress['noOrderNumberChange'] = true;
          allocationInProgress['noApsGroupChange'] = true;
          // if (!firstOrder.avgPriceGroupId || firstOrder.avgPriceGroupId.length > 0) {
          //   allocationInProgress['noApsGroupChange'] = true;
          // }
          // allocationInProgress.owner = firstTrade.owner;
          allocationInProgress.clearingHouse = this.getUniqueValue(this.significantOrders, 'clearingHouse');
          allocationInProgress.accountTypeCode = this.getUniqueValue(this.significantOrders, 'account.type');
          allocationInProgress.contractCode = this.getUniqueValue(this.significantOrders, 'contractCode');
          allocationInProgress.clearingDate = this.getUniqueValue(this.significantOrders, 'clearingDate');
          allocationInProgress.businessDate = this.getUniqueValue(this.significantOrders, 'businessDate');
          allocationInProgress.creationDate = this.getUniqueValue(this.significantOrders, 'creationDate');
          allocationInProgress.contractUnit = this.getUniqueValue(this.significantOrders, 'contractUnit');
          allocationInProgress.contractVersion = this.getUniqueValue(this.significantOrders, 'contractVersion');
          // allocationInProgress.owner = firstOrder.owner;
          allocationInProgress.customerName = this.getUniqueValue(this.significantOrders, 'customerName');
          allocationInProgress.reference1 = this.getUniqueValue(this.significantOrders, 'account.reference1');
          allocationInProgress.reference2 = this.getUniqueValue(this.significantOrders, 'account.reference2');
          allocationInProgress.executionFee = this.getUniqueValue(this.significantOrders, 'executionFee');
          allocationInProgress.giveUpCommission = this.getUniqueValue(this.significantOrders, 'giveUpCommission');
          allocationInProgress.rate = this.getUniqueValue(this.significantOrders, 'brokerageRateAmount');
          allocationInProgress.currency = this.getUniqueValue(this.significantOrders, 'brokerageCurrency');
          allocationInProgress.accountCode = this.getUniqueValue(this.significantOrders, 'account.name');
          allocationInProgress.orderReference = this.getUniqueValue(this.significantOrders, 'reference');
          allocationInProgress.giveupAccountType = this.getUniqueValue(this.significantOrders, 'giveUpAccountType');
          allocationInProgress.giveUpBrokerCode = this.getUniqueValue(this.significantOrders, 'giveUpBrokerCode');
          allocationInProgress.giveUpMessage = this.getUniqueValue(this.significantOrders, 'giveUpMessage');
          allocationInProgress.giveUpMessage2 = this.getUniqueValue(this.significantOrders, 'giveUpMessage2');
          allocationInProgress.giveUpMessage3 = this.getUniqueValue(this.significantOrders, 'giveUpMessage3');
          allocationInProgress.broker = this.getUniqueValue(this.significantOrders, 'broker');
          allocationInProgress.maturity = this.getUniqueValue(this.significantOrders, 'maturity');
          allocationInProgress.callPut = this.getUniqueValue(this.significantOrders, 'callPut');
          allocationInProgress.apsGroupId = this.getUniqueValue(this.significantOrders, 'avgPriceGroupId');
          allocationInProgress.overrideApsPrice = this.getUniqueValue(this.significantOrders, 'overrideAvgPrice');
          allocationInProgress.openClose = this.getUniqueValue(this.significantOrders, 'openClose');
          allocationInProgress.volume = this.getUniqueValue(this.significantOrders, 'volume');
          allocationInProgress.traderName = this.getUniqueValue(this.significantOrders, 'trader');
          allocationInProgress.execTrader = this.getUniqueValue(this.significantOrders, 'submittingTrader');
          // allocationInProgress.traderMemo = this.getUniqueValue(this.significantOrders, 'freeText2');
          allocationInProgress.customOrderReference = this.getUniqueValue(this.significantOrders, 'customOrderReference');
          allocationInProgress.traderMemo = this.getUniqueValue(this.significantOrders, 'freeText2');
          this.originTraderMemo = this.getUniqueValue(this.significantOrders, 'freeText2');
          allocationInProgress.moneyOwner = this.getUniqueValue(this.significantOrders, 'clearingBroker');
          // allocationInProgress.reference3 = firstOrder.account.reference3;
          // allocationInProgress.brokerageRuleType = firstOrder.brokerageRule;
          // allocationInProgress.giveUpMessage3 = firstOrder.giveUpMessage3;
          // allocationInProgress.tradeType = firstOrder.tradeType;
          // allocationInProgress.tradingEnvironment = firstOrder.tradingEnvironment;
          // allocationInProgress.strike = firstOrder.strike;
          // allocationInProgress.side = firstOrder.side;
          // allocationInProgress.desk = firstOrder.desk;
        }
      }
      this.formRecord = allocationInProgress;
      this.loadData();
      // this.filterCustomers();
      // this.filterAccounts();
      // this.filterAccountTypes();

      this.loadFooterInfos(this.formRecord.orderIds);
      this.show();
      //   } else {
      //     this.errorMessage(validation.message);
      //   }
      // });
    }
  }

  getUniqueValue(orders: Order[], field: string): any {
    let fieldValueUnique: boolean = true;
    let fieldValue: any = undefined;
    const fields = field.split('.');
    orders.forEach(order => {
      if (fieldValue
        && ((fields.length == 1 && fieldValue != order[fields[0]])
          || (fields.length == 2
            && ((order[fields[0]] == undefined && fieldValue == undefined) ||
              order[fields[0]] && fieldValue != order[fields[0]][fields[1]])))) {
        fieldValueUnique = false;
      }
      if (fields.length == 1)
        fieldValue = order[fields[0]];
      else if (fields.length == 2)
        fieldValue = order[fields[0]] ? order[fields[0]][fields[1]] : undefined;
    });
    return fieldValueUnique ? fieldValue : undefined;
  }

  getOrderChangeInfo(): string {
    let changeInfo: string = '';
    if (this.formRecord['wholeOrderNumberChange']) {
      // this.references = this.orderReferenceList.Select(l => new { l.Reference, l.ExchangeCode, l.Owner }).Distinct().Count();
      changeInfo = "Modification will be applied on the Whole Order Number " + this.formRecord.orderReference + ": " + this.orderWholeReferenceIds.length + " order(s)";
    } else {
      // this.references = this.currentOrders.Select(l => new { reference = l.Reference, exchangeCode = l.ExchangeCode, owner = l.Owner }).Distinct().Count();
      changeInfo = "Modification will be applied on the " + this.formRecord.orderIds.length + " selected order(s) and " + this.getReferences().length + " order number(s)";
      // changeInfo = "Modification will be applied on the " + this.currentOrders.Count + " selected order(s) and " + this.references + " order number(s)";
    }
    return changeInfo;
  }

  getApsGroupChangeInfo(): string {
    let changeInfo: string = '';
    if (this.formRecord['wholeOrderNumberChange']) {
      if (this.formRecord['noApsGroupChange']) {
        changeInfo = "Modification will not affect APSGroupId (current order has " + this.orderWholeApsGrpIds.length + " different APSGroupIds)";
        // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.DarkGreen;
      } else {
        changeInfo = "Modification will affect APSGroupId and replace the " + this.orderWholeApsGrpIds.length + " existing groups.";
        // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.Maroon;
      }
    } else {
      if (this.formRecord['noApsGroupChange']) {
        changeInfo = "Modification will not affect APSGroupId. (selected order(s) has " + this.getApsGrpIds().length + " different APSGroupIds)";
        // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.DarkGreen;
      } else {
        changeInfo = "Modification will affect APSGroupId and replace the " + this.getApsGrpIds().length + " existing groups.";
        // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.Maroon;
      }
    }
    return changeInfo;
  }

  // getApsGroupChangeInfoColor(): string {
  //   let changeInfoColor: string = '';
  //   if (this.formRecord['wholeOrderNumberChange']) {
  //     if (this.formRecord['noApsGroupChange']) {
  //       changeInfo = "Modification will not affect APSGroupId (current order has " + this.getApsGrpIds().length + " different APSGroupIds)";
  //       // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.DarkGreen;
  //     } else {
  //       changeInfo = "Modification will affect APSGroupId and replace the " + this.getApsGrpIds().length + " existing groups.";
  //       // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.Maroon;
  //     }
  //   } else {
  //     if (this.formRecord['noApsGroupChange']) {
  //       changeInfo = "Modification will not affect APSGroupId. (selected order(s) has " + this.getApsGrpIds().length + " different APSGroupIds)";
  //       // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.DarkGreen;
  //     } else {
  //       changeInfo = "Modification will affect APSGroupId and replace the " + this.getApsGrpIds().length + " existing groups.";
  //       // lblModificationOnAPSGroupId.Appearance.ForeColor = Color.Maroon;
  //     }
  //   }
  //   return changeInfoColor;
  // }


  saveAction() {
    this.formLoading = true;
    const finalFormRecord = {...this.formRecord};
    if (this.manageGiveUpMssg23()) {
      finalFormRecord.broker = finalFormRecord.giveUpMessage3;
    }
    if (this.formRecord['wholeOrderNumberChange'])
      finalFormRecord.orderIds = this.orderWholeReferenceIds;
    if (this.formRecord['noOrderNumberChange'])
      finalFormRecord.orderReference = undefined;
    if (this.formRecord['noApsGroupChange'])
      finalFormRecord.apsGroupId = undefined;
    else if (!finalFormRecord.apsGroupId)
      finalFormRecord.apsGroupId = ' ';
    this.allocationService.updateSingleAllocationRequest(finalFormRecord).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: finalFormRecord});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }


  protected doSave() {
    this.formLoading = true;
    const refCount = this.getReferences().length;
    if (refCount > 1) {
      this.confirmationService.confirm({
        header: this.getTranslation('page.' + this.transPartKey + '.dialog.update_references'
          , {count: refCount}),
        message: this.getTranslation('page.' + this.transPartKey + '.dialog.confirm_more_than_1_ref_update'),
        icon: 'fas fa-exclamation-triangle',
        acceptLabel: this.getTranslation('common.yes'),
        acceptButtonStyleClass: 'p-button-danger p-button-sm',
        rejectLabel: this.getTranslation('common.no'),
        rejectButtonStyleClass: 'p-button-warning p-button-sm',
        accept: () => {
          this.saveAction();
          this.formLoading = false;
        }, reject: () => {
          this.formLoading = false;
        }
      });
    } else {
      this.saveAction();
      this.formLoading = false;
    }
  }

  // getClearingHouses() {
  //   return this.getDistinctValues('clearingHouse');
  // }
  //
  // getExchangeCodes() {
  //   return this.getDistinctValues('exchangeCode');
  // }
  //
  getReferences() {
    return this.getDistinctValues('reference');
  }

  getApsGrpIds() {
    return this.getDistinctValues('avgPriceGroupId');
  }

  getDistinctValues(field: string): string[] {
    const values = [];
    this.significantOrders.forEach(value => {
      if (!values.includes(value[field]))
        values.push(value[field]);
    });
    return values;
  }

  protected getSelectionSummary(summaryRequest: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.clearingOrderInfoService.getSelectionSummary(summaryRequest);
  }

}
